import { useState, useEffect, useMemo } from 'react'
import type { FC } from 'react'
import cn from 'classnames'
import { SellerInline } from 'modules/sellers/components'
import { ProductService } from 'modules/products/services'
import type { Product } from 'framework/products'
import parser from 'fazendinha/product'
import { BrowserView, MobileOnlyView } from 'react-device-detect'
import { ProductCarousel } from 'modules/products/components'
import type { ProductGridWithSellerProps } from '.'
import s from './product-grid-with-seller.module.css'
import { ProductCard } from '..'

const ProductGridWithSeller: FC<ProductGridWithSellerProps> = ({ className, seller }) => {
  const [products, setProducts] = useState<Product[]>([] as Product[])

  function getProducts() {
    const productService = new ProductService()
    return productService.query({
      categories: '',
      search: '',
      page: 1,
      seller: seller.id,
    })
  }

  useEffect(() => {
    if (seller && seller.id) {
      getProducts().then(({ data: { data } }: { data: { data: any[] } }) => {
        setProducts(data.map((product) => parser(product)))
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const firstLine = useMemo(() => {
    if (products.length > 0) {
      return [products[0], products[1], products[2]].filter(Boolean)
    }
    return []
  }, [products])

  const lastLine = useMemo(() => {
    if (products.length > 0) {
      return [products[3], products[4], products[5], products[6], products[7], products[8]].filter(Boolean)
    }
    return []
  }, [products])

  return (
    <div className={cn(s.root, className)}>
      <div className={s.header}>
        <SellerInline {...seller} className={s.seller} />
        <span className={s.new}>Ofertas no Atacado</span>
      </div>
      <BrowserView viewClassName={s.line}>
        <div className={s.banner}>
          <a href="https://www.fazendinha.me/produtos/atacado">
            <img src="/assets/images/26-07/banneratacadodesktop.jpg" alt={seller.name} />
          </a>
        </div>
        {firstLine.map((p) => (
          <ProductCard product={p} />
        ))}
      </BrowserView>
      <BrowserView viewClassName={s.line}>
        {lastLine.map((p) => (
          <ProductCard product={p} />
        ))}
      </BrowserView>
      <MobileOnlyView>
        <div className={s.banner}>
          <a href="https://www.fazendinha.me/produtos/atacado">
            <img src="/assets/images/26-07/banneratacadomobile.jpg" alt={seller.name} />
          </a>
        </div>
        <ProductCarousel>
          {products.map((product) => (
            <ProductCard key={`product-grid-seller-product-${product.id}`} product={product} />
          ))}
        </ProductCarousel>
      </MobileOnlyView>
    </div>
  )
}

export default ProductGridWithSeller
